import React, { useState } from 'react';

const PackingStationCard = ({
  loading = false,
  width = '100%',
  height = 'auto',
  maxWidth = '416px',
  maxHeight = '287px',
  selectedDate = '2025-08-03'
}) => {
  // Real cycle data from August 3rd only
  const cycleData = [
    {
      date: '2025-08-03',
      start_time: '0:00:12',
      end_time: '0:02:20',
      duration_sec: 127.89,
      process_times: {
        productVerification: 63,
        bubbleWrapping: 20,
        hexpaperPlacing: 8,
        bubblewrapPlacing: 24,
        TapingLabelpasting: 13
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:02:20',
      end_time: '0:04:36',
      duration_sec: 135.45,
      process_times: {
        productVerification: 62,
        bubbleWrapping: 37,
        hexpaperPlacing: 2,
        bubblewrapPlacing: 16,
        TapingLabelpasting: 19
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:04:36',
      end_time: '0:06:38',
      duration_sec: 122.08,
      process_times: {
        productVerification: 56,
        bubbleWrapping: 16,
        hexpaperPlacing: 3,
        bubblewrapPlacing: 17,
        TapingLabelpasting: 30
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:06:38',
      end_time: '0:09:14',
      duration_sec: 156.52,
      process_times: {
        productVerification: 79,
        bubbleWrapping: 24,
        hexpaperPlacing: 9,
        TapingLabelpasting: 44
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:09:14',
      end_time: '0:10:00',
      duration_sec: 45.36,
      process_times: {
        productVerification: 45,
        bubbleWrapping: 1
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:00:33',
      end_time: '0:02:52',
      duration_sec: 139.57,
      process_times: {
        productVerification: 0,
        bubbleWrapping: 26,
        hexpaperPlacing: 2,
        bubblewrapPlacing: 7,
        TapingLabelpasting: 104
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:02:52',
      end_time: '0:05:19',
      duration_sec: 146.29,
      process_times: {
        productVerification: 82,
        bubbleWrapping: 17,
        hexpaperPlacing: 1,
        bubblewrapPlacing: 26,
        TapingLabelpasting: 21
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:05:19',
      end_time: '0:07:19',
      duration_sec: 120.11,
      process_times: {
        productVerification: 53,
        bubbleWrapping: 34,
        hexpaperPlacing: 2,
        bubblewrapPlacing: 22,
        TapingLabelpasting: 9
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:07:19',
      end_time: '0:07:24',
      duration_sec: 5.46,
      process_times: {
        productVerification: 5
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:00:26',
      end_time: '0:02:30',
      duration_sec: 123.97,
      process_times: {
        productVerification: 62,
        bubbleWrapping: 13,
        bubblewrapPlacing: 24,
        TapingLabelpasting: 25
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:02:30',
      end_time: '0:04:43',
      duration_sec: 133.91,
      process_times: {
        productVerification: 78,
        bubbleWrapping: 18,
        hexpaperPlacing: 4,
        bubblewrapPlacing: 29,
        TapingLabelpasting: 4
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:00:53',
      end_time: '0:02:48',
      duration_sec: 115.92,
      process_times: {
        productVerification: 53,
        bubbleWrapping: 15,
        bubblewrapPlacing: 17,
        TapingLabelpasting: 30
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:02:48',
      end_time: '0:05:19',
      duration_sec: 150.78,
      process_times: {
        productVerification: 80,
        bubbleWrapping: 30,
        hexpaperPlacing: 4,
        bubblewrapPlacing: 10,
        TapingLabelpasting: 27
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:05:19',
      end_time: '0:07:05',
      duration_sec: 105.42,
      process_times: {
        productVerification: 57,
        bubbleWrapping: 12,
        hexpaperPlacing: 2,
        bubblewrapPlacing: 13,
        TapingLabelpasting: 22
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:07:05',
      end_time: '0:09:02',
      duration_sec: 117.32,
      process_times: {
        productVerification: 56,
        bubbleWrapping: 12,
        bubblewrapPlacing: 4,
        hexpaperPlacing: 15,
        TapingLabelpasting: 30
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:09:02',
      end_time: '0:10:00',
      duration_sec: 57.68,
      process_times: {
        productVerification: 58
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:00:33',
      end_time: '0:02:52',
      duration_sec: 139.57,
      process_times: {
        productVerification: 0,
        bubbleWrapping: 26,
        hexpaperPlacing: 2,
        bubblewrapPlacing: 7,
        TapingLabelpasting: 104
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:02:52',
      end_time: '0:05:19',
      duration_sec: 146.29,
      process_times: {
        productVerification: 82,
        bubbleWrapping: 17,
        hexpaperPlacing: 1,
        bubblewrapPlacing: 26,
        TapingLabelpasting: 21
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:05:19',
      end_time: '0:07:19',
      duration_sec: 120.11,
      process_times: {
        productVerification: 53,
        bubbleWrapping: 34,
        hexpaperPlacing: 2,
        bubblewrapPlacing: 22,
        TapingLabelpasting: 9
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:07:19',
      end_time: '0:07:24',
      duration_sec: 5.46,
      process_times: {
        productVerification: 5
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:00:12',
      end_time: '0:02:20',
      duration_sec: 127.89,
      process_times: {
        productVerification: 63,
        bubbleWrapping: 20,
        hexpaperPlacing: 8,
        bubblewrapPlacing: 24,
        labelPasting: 13
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:02:20',
      end_time: '0:04:36',
      duration_sec: 135.45,
      process_times: {
        productVerification: 62,
        bubbleWrapping: 37,
        hexpaperPlacing: 2,
        bubblewrapPlacing: 16,
        TapingLabelpasting: 19
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:04:36',
      end_time: '0:06:38',
      duration_sec: 122.08,
      process_times: {
        productVerification: 56,
        bubbleWrapping: 16,
        hexpaperPlacing: 3,
        bubblewrapPlacing: 17,
        TapingLabelpasting: 30
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:06:38',
      end_time: '0:09:14',
      duration_sec: 156.52,
      process_times: {
        productVerification: 79,
        bubbleWrapping: 24,
        hexpaperPlacing: 9,
        TapingLabelpasting: 44
      }
    },
    {
      date: '2025-08-03',
      start_time: '0:09:14',
      end_time: '0:10:00',
      duration_sec: 45.36,
      process_times: {
        productVerification: 45,
        bubbleWrapping: 1
      }
    }
  ];

  // Filter cycle data based on selected date - ONLY show data for August 3rd, 2025
  const getFilteredCycleData = () => {
    const targetDate = '2025-08-03'; // Fixed target date

    if (!selectedDate) {
      // If no date is selected, don't show any data
      return [];
    }

    // Convert selectedDate to YYYY-MM-DD format for comparison
    let selectedDateStr;
    try {
      if (typeof selectedDate === 'string') {
        // Handle string dates
        selectedDateStr = selectedDate.includes('T') ? selectedDate.split('T')[0] : selectedDate;
      } else {
        // Handle Date objects
        selectedDateStr = new Date(selectedDate).toISOString().split('T')[0];
      }
    } catch (error) {
      console.error('Date parsing error:', error);
      return [];
    }

    console.log('Selected Date String:', selectedDateStr, 'Target Date:', targetDate);

    // Only return data if the selected date matches August 3rd, 2025
    if (selectedDateStr === targetDate) {
      return cycleData.filter((cycle) => cycle.date === targetDate);
    }

    // Return empty array for any other date
    return [];
  };

  const filteredCycleData = getFilteredCycleData();
  const hasPackingData = filteredCycleData.length > 0;

  // Convert real data to station format - only use filtered data
  const packingData = hasPackingData
    ? {
        totalStations: filteredCycleData.length,
        activeStations: filteredCycleData.length,
        efficiency: 92,
        packagesProcessed: 1247,
        avgPackingTime: 3.2,
        stations: filteredCycleData.map((cycle, index) => ({
          id: `Cycle ${index + 1}`,
          status: 'active',
          packagesPerHour: Math.round(3600 / cycle.duration_sec),
          operator: `Station ${String.fromCharCode(65 + (index % 8))}`,
          efficiency: Math.round(85 + Math.random() * 15),
          process_times: cycle.process_times,
          start_time: cycle.start_time,
          end_time: cycle.end_time,
          duration_sec: cycle.duration_sec
        }))
      }
    : {
        totalStations: 0,
        activeStations: 0,
        efficiency: 0,
        packagesProcessed: 0,
        avgPackingTime: 0,
        stations: []
      };

  /** --------- SVG Icons --------- */
  const PackageIconSVG = ({ size = 24, color = '#36C5F0' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M2 17L12 22L22 17" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2 12L12 17L22 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const StationIconSVG = ({ size = 20, color = '#718EBF' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <rect x="3" y="3" width="18" height="18" rx="2" stroke={color} strokeWidth="2" fill="none" />
      <path d="M9 9h6v6H9z" fill={color} opacity="0.3" />
      <path d="M9 3v18M15 3v18M3 9h18M3 15h18" stroke={color} strokeWidth="1" opacity="0.5" />
    </svg>
  );

  // const EfficiencyIconSVG = ({ size = 20, color = '#22C55E' }) => (
  //   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
  //     <path
  //       d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
  //       stroke={color}
  //       strokeWidth="2"
  //       fill="none"
  //     />
  //     <path d="M8 12L11 15L16 9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  //   </svg>
  // );

  const ClockIconSVG = ({ size = 16, color = '#A78BFA' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2" fill="none" />
      <path d="M12 6v6l4 2" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );

  // Process colors for progress bar
  const processColors = {
    productVerification: '#22C55E',
    bubbleWrapping: '#3B82F6',
    hexpaperPlacing: '#F59E0B',
    bubblewrapPlacing: '#EF4444',
    TapingLabelpasting: '#A78BFA',
    labelPasting: '#A78BFA'
  };

  const processLabels = {
    productVerification: 'Product Verification',
    bubbleWrapping: 'Bubble Wrapping',
    hexpaperPlacing: 'Hexpaper Placing',
    bubblewrapPlacing: 'Bubblewrap Placing',
    TapingLabelpasting: 'Taping & Label Pasting',
    labelPasting: 'Label Pasting'
  };

  /** --------- Horizontal Progress Bar --------- */
  const HorizontalProgressBar = ({ station }) => {
    const [hoveredSegment, setHoveredSegment] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

    if (!station.process_times) return null;

    const totalTime = Object.values(station.process_times).reduce((sum, time) => sum + time, 0);

    const segments = Object.entries(station.process_times)
      .filter(([, time]) => time > 0) // Only show processes with time > 0
      .map(([process, time]) => {
        const percentage = (time / totalTime) * 100;
        return {
          process,
          time,
          percentage,
          color: processColors[process] || '#718EBF' // Fallback color
        };
      });

    const handleMouseEnter = (segment, event) => {
      console.log('Mouse enter triggered:', segment);
      setHoveredSegment(segment);
      setTooltipPosition({ x: event.clientX, y: event.clientY });
    };

    const handleMouseMove = (segment, event) => {
      if (hoveredSegment && hoveredSegment.process === segment.process) {
        setTooltipPosition({ x: event.clientX, y: event.clientY });
      }
    };

    const handleMouseLeave = () => {
      setHoveredSegment(null);
    };

    return (
      <div style={{ position: 'relative', width: '100%', padding: '12px 0' }}>
        {/* Progress bar container */}
        <div
          style={{
            width: '80%',
            height: '20px',
            background: 'linear-gradient(90deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.12) 100%)',
            borderRadius: '8px',
            overflow: 'hidden',
            display: 'flex',
            position: 'relative',
            border: '1px solid rgba(255,255,255,0.1)',
            boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)',
            margin: '0 auto'
          }}
        >
          {segments.map((segment, index) => (
            <div
              key={`${segment.process}-${index}`}
              style={{
                width: `${segment.percentage}%`,
                height: '100%',
                background: `linear-gradient(180deg, ${segment.color} 0%, ${segment.color}CC 100%)`,
                cursor: 'pointer',
                opacity: hoveredSegment && hoveredSegment.process !== segment.process ? 0.4 : 1,
                transition: 'all 0.3s ease',
                borderRadius: index === 0 ? '7px 0 0 7px' : index === segments.length - 1 ? '0 7px 7px 0' : '0',
                position: 'relative',
                transform: hoveredSegment && hoveredSegment.process === segment.process ? 'scaleY(1.2)' : 'scaleY(1)',
                boxShadow: hoveredSegment && hoveredSegment.process === segment.process ? `0 0 12px ${segment.color}88` : 'none',
                minWidth: '8px'
              }}
              onMouseEnter={(e) => {
                console.log('Hovering over:', segment.process, segment.time + 's');
                handleMouseEnter(segment, e);
              }}
              onMouseMove={(e) => handleMouseMove(segment, e)}
              onMouseLeave={() => {
                console.log('Left hover');
                handleMouseLeave();
              }}
              title={`${processLabels[segment.process] || segment.process}: ${segment.time}s`}
            />
          ))}
        </div>

        {/* Enhanced Tooltip */}
        {hoveredSegment && (
          <div
            style={{
              position: 'fixed',
              left: tooltipPosition.x + 15,
              top: tooltipPosition.y - 15,
              background: 'linear-gradient(135deg, rgba(0,0,0,0.95) 0%, rgba(20,20,20,0.95) 100%)',
              color: '#fff',
              padding: '12px 16px',
              borderRadius: '8px',
              fontSize: '13px',
              fontWeight: 600,
              zIndex: 9999,
              pointerEvents: 'none',
              border: `2px solid ${hoveredSegment.color}`,
              boxShadow: `0 8px 24px rgba(0,0,0,0.4), 0 0 16px ${hoveredSegment.color}33`,
              backdropFilter: 'blur(8px)',
              minWidth: '180px'
            }}
          >
            <div
              style={{
                color: hoveredSegment.color,
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: 700,
                textAlign: 'center'
              }}
            >
              {processLabels[hoveredSegment.process] || hoveredSegment.process}
            </div>
            <div
              style={{
                textAlign: 'center',
                fontSize: '16px',
                fontWeight: 700,
                color: '#fff'
              }}
            >
              {hoveredSegment.time} seconds
            </div>
            <div
              style={{
                textAlign: 'center',
                fontSize: '12px',
                color: 'rgba(255,255,255,0.7)',
                marginTop: '4px'
              }}
            >
              {hoveredSegment.percentage.toFixed(1)}% of cycle
            </div>
          </div>
        )}
      </div>
    );
  };

  // Status colors
  // const getStatusColor = (status) => {
  //   switch (status) {
  //     case 'active':
  //       return { bg: 'rgba(34, 197, 94, 0.15)', border: 'rgba(34, 197, 94, 0.35)', text: '#22C55E' };
  //     case 'maintenance':
  //       return { bg: 'rgba(239, 68, 68, 0.15)', border: 'rgba(239, 68, 68, 0.35)', text: '#EF4444' };
  //     case 'idle':
  //       return { bg: 'rgba(156, 163, 175, 0.15)', border: 'rgba(156, 163, 175, 0.35)', text: '#9CA3AF' };
  //     default:
  //       return { bg: 'rgba(156, 163, 175, 0.15)', border: 'rgba(156, 163, 175, 0.35)', text: '#9CA3AF' };
  //   }
  // };

  /** --------- No Data Message --------- */
  // const NoDataMessage = () => (
  //   <div
  //     style={{
  //       display: 'flex',
  //       flexDirection: 'column',
  //       alignItems: 'center',
  //       justifyContent: 'center',
  //       minHeight: '120px',
  //       textAlign: 'center',
  //       padding: '16px',
  //       background: 'linear-gradient(135deg, rgba(156, 163, 175, 0.08) 0%, rgba(156, 163, 175, 0.04) 100%)',
  //       borderRadius: '12px',
  //       border: '1px solid rgba(156, 163, 175, 0.15)'
  //     }}
  //   >
  //     <div
  //       style={{
  //         fontSize: '14px',
  //         fontWeight: 600,
  //         color: 'rgba(255, 255, 255, 0.8)',
  //         marginBottom: '8px'
  //       }}
  //     >
  //       No Data Available
  //     </div>

  //     <div
  //       style={{
  //         fontSize: '12px',
  //         color: 'rgba(255, 255, 255, 0.5)',
  //         lineHeight: 1.4
  //       }}
  //     >
  //       {selectedDate ? `No data available for ${new Date(selectedDate).toLocaleDateString()}` : 'Please select a date to view data'}
  //       <br />
  //       <strong style={{ color: '#36C5F0' }}>Data available only on August 3rd, 2025</strong>
  //     </div>
  //   </div>
  // );

  /** --------- Skeleton --------- */
  const SkeletonLoader = () => (
    <>
      <div
        style={{
          width: '100%',
          height: '80px',
          borderRadius: '12px',
          background: 'linear-gradient(90deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.04) 50%, rgba(255,255,255,0.08) 100%)',
          marginBottom: '16px'
        }}
      />
      <div
        style={{
          width: '60%',
          height: '20px',
          backgroundColor: 'rgba(255,255,255,0.08)',
          borderRadius: '4px',
          marginBottom: '12px'
        }}
      />
      <div
        style={{
          width: '100%',
          height: '120px',
          backgroundColor: 'rgba(255,255,255,0.06)',
          borderRadius: '8px'
        }}
      />
    </>
  );

  /** --------- Pill Header --------- */
  const PillHeader = () => (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: 'clamp(80px, 12vw, 90px)',
        borderRadius: '16px',
        padding: 'clamp(12px, 3vw, 16px)',
        display: 'flex',
        alignItems: 'center',
        color: '#fff',
        overflow: 'hidden',
        background: 'linear-gradient(180deg, rgba(20,31,74,0.9) 0%, rgba(12,18,48,0.9) 100%)',
        boxShadow: 'inset 0 0 0 1px rgba(54,197,240,0.55), 0 8px 22px rgba(0,0,0,0.35)',
        marginBottom: 'clamp(16px, 3vw, 20px)'
      }}
    >
      {/* slanted dark overlay */}
      <div
        style={{
          position: 'absolute',
          right: '-20%',
          top: 0,
          bottom: 0,
          width: '70%',
          transform: 'skewX(-18deg)',
          background: 'linear-gradient(180deg, rgba(7,12,32,0.65) 0%, rgba(7,12,32,0.2) 100%)',
          filter: 'blur(0.2px)'
        }}
      />

      {/* LEFT: Title, chip and total count */}
      <div style={{ position: 'relative', zIndex: 2, flex: 1, minWidth: 0 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 8
          }}
        >
          <div
            style={{
              fontSize: 'clamp(14px, 2.5vw, 16px)',
              fontWeight: 600,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontFamily: 'Plus Jakarta Sans, sans-serif'
            }}
          >
            Packing Stations
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            gap: 8,
            minWidth: 0
          }}
        >
          <div
            style={{
              fontSize: 'clamp(28px, 6vw, 36px)',
              fontWeight: 300,
              lineHeight: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {hasPackingData ? `${packingData.activeStations}/${packingData.totalStations}` : '0/0'}
          </div>
          <div
            style={{
              fontSize: 'clamp(10px, 2vw, 12px)',
              opacity: 0.8,
              flexShrink: 0
            }}
          >
            Active Cycles
          </div>
        </div>
      </div>

      {/* RIGHT: package icon */}
      <div
        style={{
          position: 'absolute',
          right: 'clamp(12px, 3vw, 16px)',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 3,
          flexShrink: 0
        }}
      >
        <PackageIconSVG size={window.innerWidth < 480 ? 32 : 40} color="#36C5F0" />
      </div>
    </div>
  );

  /** --------- Component --------- */
  return (
    <div
      style={{
        position: 'relative',
        width: width,
        height: height,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
        minWidth: '280px',
        borderRadius: '20px',
        background: 'linear-gradient(127deg, rgba(6,11,40,0.94) 19.41%, rgba(10,14,35,0.49) 76.65%)',
        backdropFilter: 'blur(60px)',
        padding: 'clamp(16px, 4vw, 20px)',
        color: '#fff',
        overflow: 'hidden',
        boxShadow: '0 12px 28px rgba(0,0,0,0.45)',
        minHeight: '200px'
      }}
    >
      {loading ? (
        <SkeletonLoader />
      ) : (
        <>
          {/* Header pill */}
          <PillHeader />

          {/* STATISTICS list */}
          <div style={{ marginTop: 0 }}>
            <div
              style={{
                fontSize: 'clamp(10px, 2vw, 12px)',
                letterSpacing: '1.4px',
                color: 'rgba(226,232,240,0.75)',
                marginBottom: 'clamp(12px, 2.5vw, 16px)'
              }}
            >
              STATISTICS
            </div>

            {!hasPackingData ? (
            ''
            ) : (
              <div
                style={{
                  maxHeight: 'clamp(100px, 18vw, 120px)',
                  overflowY: 'auto',
                  paddingRight: 8,
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none'
                }}
                className="no-scrollbar"
              >
                {packingData.stations.map((station, idx) => (
                  <div key={station.id} style={{ marginBottom: 16 }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                        marginBottom: 10
                      }}
                    >
                      <div
                        style={{
                          width: 'clamp(32px, 5vw, 36px)',
                          height: 'clamp(32px, 5vw, 36px)',
                          borderRadius: '50%',
                          background: 'rgba(54,197,240,0.18)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          outline: '1px solid rgba(54,197,240,0.35)',
                          flexShrink: 0
                        }}
                      >
                        <StationIconSVG size={20} color="#36C5F0" />
                      </div>
                      <div
                        style={{
                          fontSize: 'clamp(16px, 3vw, 18px)',
                          fontWeight: 700,
                          flex: 1,
                          minWidth: 0,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {station.id}
                      </div>
                    </div>

                    <div
                      style={{
                        marginLeft: '48px',
                        marginTop: '8px',
                        width: 'calc(100% - 48px)'
                      }}
                    >
                      {station.status === 'active' && station.process_times ? (
                        <HorizontalProgressBar station={station} />
                      ) : (
                        <div
                          style={{
                            width: '72px',
                            height: '72px',
                            borderRadius: '50%',
                            background: 'rgba(255,255,255,0.05)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1px solid rgba(255,255,255,0.1)'
                          }}
                        >
                          <div
                            style={{
                              fontSize: '12px',
                              color: 'rgba(255,255,255,0.4)',
                              textAlign: 'center'
                            }}
                          >
                            {station.status === 'maintenance' ? 'Under\nMaintenance' : 'Idle'}
                          </div>
                        </div>
                      )}
                    </div>

                    {idx < packingData.stations.length - 1 && (
                      <div
                        style={{
                          margin: '16px 0',
                          height: 1,
                          backgroundColor: 'rgba(255,255,255,0.06)'
                        }}
                      />
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* Summary Stats - only show when data is available */}
            {hasPackingData && (
              <div
                style={{
                  marginTop: '16px',
                  padding: '12px',
                  borderRadius: '8px',
                  background: 'linear-gradient(135deg, rgba(54, 197, 240, 0.08) 0%, rgba(167, 139, 250, 0.08) 100%)',
                  border: '1px solid rgba(54, 197, 240, 0.15)'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: '10px',
                        color: 'rgba(255, 255, 255, 0.6)',
                        marginBottom: '2px'
                      }}
                    >
                      Avg Packing Time
                    </div>
                    <div
                      style={{
                        fontSize: '14px',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}
                    >
                      <ClockIconSVG size={12} color="#A78BFA" />
                      {packingData.avgPackingTime} min
                    </div>
                  </div>

                  <div style={{ textAlign: 'right' }}>
                    <div
                      style={{
                        fontSize: '10px',
                        color: 'rgba(255, 255, 255, 0.6)',
                        marginBottom: '2px'
                      }}
                    >
                      Overall Efficiency
                    </div>
                    <div
                      style={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: '#22C55E'
                      }}
                    >
                      {packingData.efficiency}%
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      {/* soft radial glow */}
      <div
        style={{
          position: 'absolute',
          top: '-40%',
          right: '-20%',
          width: 360,
          height: 360,
          borderRadius: '50%',
          background: 'radial-gradient(closest-side, rgba(255,255,255,0.06), rgba(255,255,255,0))',
          pointerEvents: 'none',
          filter: 'blur(2px)'
        }}
      />
    </div>
  );
};

export default PackingStationCard;
